var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockUnlocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdi-light:lock-unlocked") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Access-Control",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    id: "BP-My-BP-details---Access-Control---new-6",
    transform: "translate(-37.000000, -478.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mdi-light:lock-unlocked",
    transform: "translate(37.000000, 478.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    fill: "#000000",
    fillOpacity: 0.886
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,9 C19.863961,9 21.375,10.511039 21.375,12.375 L21.375,21.375 C21.375,23.238961 19.863961,24.75 18,24.75 L7.875,24.75 C6.01103897,24.75 4.5,23.238961 4.5,21.375 L4.5,12.375 C4.5,10.511039 6.01103897,9 7.875,9 L16.875,9 L16.875,7.3125 C16.8787247,5.24454952 15.28209,3.52608691 13.2194442,3.3780147 C11.1567984,3.2299425 9.33107225,4.70272235 9.039375,6.75 L7.905375,6.75 C8.19956199,4.07621035 10.5334084,2.09935011 13.2191671,2.2490079 C15.9049257,2.39866569 18.0046936,4.62257899 18,7.3125 L18,9 Z M7.875,10.125 C6.63235931,10.125 5.625,11.1323593 5.625,12.375 L5.625,21.375 C5.625,22.6176407 6.63235931,23.625 7.875,23.625 L18,23.625 C19.2426407,23.625 20.25,22.6176407 20.25,21.375 L20.25,12.375 C20.25,11.1323593 19.2426407,10.125 18,10.125 L7.875,10.125 Z M12.9375,15.75 C12.0055195,15.75 11.25,16.5055195 11.25,17.4375 C11.25,18.3694805 12.0055195,19.125 12.9375,19.125 C13.8694805,19.125 14.625,18.3694805 14.625,17.4375 C14.625,16.5055195 13.8694805,15.75 12.9375,15.75 Z M12.9375,14.625 C14.4908009,14.625 15.75,15.8841991 15.75,17.4375 C15.75,18.9908009 14.4908009,20.25 12.9375,20.25 C11.3841991,20.25 10.125,18.9908009 10.125,17.4375 C10.125,15.8841991 11.3841991,14.625 12.9375,14.625 L12.9375,14.625 Z",
    id: "Icon-Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockUnlocked);
export default __webpack_public_path__ + "static/media/lock-unlocked.1615c4255cf58bf141b9b308b505323c.svg";
export { ForwardRef as ReactComponent };